module.exports = __webpack_public_path__ + "img/success.946297f0.svg";